import {
    Button,
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Heading,
    Input,
    Select,
    Textarea,
    Tag,
    Box
} from '@chakra-ui/react';
import { Field, Form, Formik } from 'formik';
import React, { useEffect, useRef, useState } from 'react';
import Swal from "sweetalert2";
import DoencaService from "../../../main/services/DoencaService";
import { useHistory } from 'react-router-dom';
import { useAuthProvider } from '../../../Context/AuthProvider';
import { doencaFunc } from '../../../helpers/Funcionalidades';
import SemRegistros from '../../components/SemRegistros';
import { Group } from '../Criancas/Group';

const AlterarVigenciaDoenca = (props) => {
    let history = useHistory();
    document.title = 'MCA - Doenças - Alterar Vigência'

    const { roleKeycloack } = useAuthProvider();
    const _IsMounted = useRef(false);
    const [doenca, setDoenca] = useState([])
    const [justificativaCount, setJustificativaCount] = useState(0);


    useEffect(() => {

        _IsMounted.current = true;
        fetchData();
        return () => {
            _IsMounted.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    function fetchData() {
        DoencaService.getDoenca(props.match.params.id)
            .then(res => {
                setDoenca(res.data);
            }).catch((err) => {
                Swal.fire({
                    title: 'Erro!',
                    'text': err.response.data.message ? err.response.data.message : "Houve um erro na requisição",
                    icon: 'error',
                    confirmButtonText: 'Fechar',
                    confirmButtonColor: '#169499'
                }).then(function () {
                    history.push("/doenca/lista");
                });
            })
    }
    return roleKeycloack && roleKeycloack.includes(doenca.dataFim ? doencaFunc.doencaReativar : doencaFunc.doencaInativar) ? (
        <Flex
            pt={"20px"}
            px={["5px", "30px"]}
            h="100%"
            flexDir="column"
            w="100%"
            maxW="2000px"
            overflow="auto"
            pb={["10px", "20px"]}
        >
            <Flex
                flexDir="row"
                justifyContent="space-between"
            >

                <Heading fontSize={'large'}>
                    {doenca.dataFim ? "Reativar Doença" : "Inativar Doença"}
                </Heading>
                <Button onClick={history.goBack} colorScheme={"teal"} px={16}>
                    Voltar
                </Button>
            </Flex>
            <Formik
                enableReinitialize
                validateOnChange={false}
                validateOnBlur={false}
                initialValues={{
                    descricao: doenca.descricao || "",
                    justificativaAntiga: doenca.justificativa ? doenca.justificativa : "" || "",
                    dispensaLaudo: doenca.dispensaLaudo ? doenca.dispensaLaudo : "" || ""
                }}
                onSubmit={(values, { setFieldError, setSubmitting }) => {
                    let updated;
                    DoencaService.getDoenca(props.match.params.id)
                        .then(res => {
                            updated = res.data
                            const acaoUp = updated.dataFim ? "reativar" : "inativar";
                            if (acaoUp !== (doenca.dataFim ? "reativar" : "inativar")) {
                                Swal.fire({
                                    title: 'Atenção',
                                    text: updated.dataFim ?
                                        "Este registro já está inativo. Deseja reativá-lo?" :
                                        "Este registro está ativo. Deseja inativá-lo?",
                                    icon: 'warning',
                                    showCancelButton: true,
                                    confirmButtonColor: '#169499',
                                    cancelButtonColor: '#169499',
                                    confirmButtonText: updated.dataFim ?
                                        "Sim, quero reativar!" :
                                        "Sim, quero inativar!",
                                    cancelButtonText: 'Cancelar'
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        fetchData();
                                    }
                                })
                                setSubmitting(false);
                            } else {
                                if (doenca.dataFim) {
                                    DoencaService.reativarDoenca(doenca.id, values)
                                        .then((res) => {
                                            Swal.fire({
                                                title: 'Sucesso!',
                                                'text': 'Registro reativado com sucesso!',
                                                icon: 'success',
                                                confirmButtonText: 'Continuar',
                                                confirmButtonColor: '#169499'
                                            }).then(function () {
                                                history.push("/doenca/lista");
                                            });

                                        }).catch((error) => {
                                            setFieldError(error.response && error.response.data.field, error.response && error.response.data.message)
                                            setSubmitting(false);
                                        })
                                } else {
                                    DoencaService.inativarDoenca(doenca.id, values)
                                        .then((res) => {
                                            Swal.fire({
                                                title: 'Sucesso!',
                                                'text': 'Registro inativado com sucesso!',
                                                icon: 'success',
                                                confirmButtonText: 'Continuar',
                                                confirmButtonColor: '#169499'
                                            }).then(function () {
                                                history.push("/doenca/lista");
                                            });
                                        }).catch((error) => {
                                            setFieldError(error.response && error.response.data.field, error.response && error.response.data.message)
                                            setSubmitting(false);
                                        })
                                }
                                setSubmitting(false);
                            }
                        }).catch((error) => {
                            setSubmitting(false);
                        })
                }}
            >
                {(props) => (
                    <Flex
                        flexDir={"column"}
                        mt={"40px"}
                        w={"100%"}>
                        <Form>
                            <Flex
                                flexDir={"column"}>
                                <Group bgColor="#fff" title="" py="12px" >
                                    <Box width={{ lg: '50%' }}>
                                        <Field name="descricao">
                                            {({ field, form }) => (
                                                <Flex flexDir="column">
                                                    <FormControl isInvalid={form.errors.descricao && form.touched.descricao}>
                                                        <FormLabel htmlFor="descricao">Descrição</FormLabel>
                                                        <Input
                                                            isDisabled
                                                            focusBorderColor={"false"}
                                                            backgroundColor={"#D7D8DE"}
                                                            id="descricao"
                                                            {...field}
                                                            placeholder="Informe a Descrição da Doença"
                                                            h="42px"
                                                        />
                                                        <FormErrorMessage>{form.errors.descricao}</FormErrorMessage>
                                                    </FormControl>
                                                </Flex>
                                            )}
                                        </Field>
                                        <Field name="dispensaLaudo">
                                            {({ field, form }) => (
                                                <Flex mt={5} flexDir="column">
                                                    <FormControl isInvalid={form.errors.dispensaLaudo && form.touched.dispensaLaudo}>
                                                        <FormLabel htmlFor="dispensaLaudo">Dispensa Laudo Médico para Efeitos do QUF/MPRJ?</FormLabel>
                                                        <Select
                                                            cursor={"default"}
                                                            isDisabled
                                                            focusBorderColor={true}
                                                            id="tipo"
                                                            {...field}
                                                            placeholder="Selecione"
                                                            h="42px"
                                                        >
                                                            <option value={"S"}>Sim</option>
                                                            <option value={"N"}>Não</option>
                                                        </Select>
                                                        <FormErrorMessage>{form.errors.dispensaLaudo}</FormErrorMessage>
                                                    </FormControl>
                                                </Flex>
                                            )}
                                        </Field>
                                        {doenca.dataFim ? (
                                            <Field name="justificativaAntiga">
                                                {({ field, form }) => (
                                                    <Flex flexDir="column" mt={10}>
                                                        <FormControl isInvalid={form.errors.justificativaAntiga && form.touched.justificativaAntiga}>
                                                            <FormLabel htmlFor="justificativaAntiga">Justificativa de Inativação</FormLabel>
                                                            <Textarea
                                                                w="100%"
                                                                cursor={"default"}
                                                                focusBorderColor={"none"}
                                                                isDisabled
                                                                backgroundColor={"#D7D8DE"}
                                                                id="justificativaAntiga"
                                                                {...field}
                                                                placeholder="Justificativa da Ativação/Inativação" />

                                                        </FormControl>
                                                    </Flex>
                                                )}
                                            </Field>
                                        ) : (
                                            <></>
                                        )}
                                        <Field name="justificativa">
                                            {({ field, form }) => (
                                                <Flex flexDir="column" mt={10}>
                                                    <FormControl isInvalid={form.errors.justificativa && form.touched.justificativa}>
                                                        <FormLabel htmlFor="justificativa">Justificativa de {doenca.dataFim ? "Reativação" : "Inativação"}</FormLabel>
                                                        <Textarea
                                                            autoFocus
                                                            w="100%"
                                                            backgroundColor={"white"}
                                                            id="justificativa"
                                                            {...field}
                                                            placeholder="Justificativa da Ativação/Inativação"
                                                            maxLength={4000}
                                                            onChange={(e) => {
                                                                setJustificativaCount(e.target.value.length);
                                                                form.setFieldValue(field.name, e.target.value);
                                                            }}
                                                        />
                                                        <FormErrorMessage>{form.errors.justificativa}</FormErrorMessage>
                                                    </FormControl>
                                                </Flex>
                                            )}
                                        </Field>
                                        <Flex flexDirection="row-reverse">
                                            <Tag maxW="max-content">{`${justificativaCount}/4000`}</Tag>
                                        </Flex>

                                    </Box>
                                </Group>
                            </Flex>

                            <Flex mt={2} justifyContent="space-between">
                                <Flex></Flex>
                                <Button
                                    mt={4}
                                    mr={2}
                                    colorScheme={"teal"}
                                    px={14}
                                    isLoading={props.isSubmitting}
                                    type="submit"
                                    translate="no">
                                    {doenca.dataFim ? "Reativar" : "Inativar"}
                                </Button>
                            </Flex>

                        </Form>
                    </Flex>
                )}

            </Formik >
        </Flex >
    ) : (
        <Box mt={2}>
            <SemRegistros buttonVisible={true} half />
        </Box>
    )
}
export default AlterarVigenciaDoenca;
